import type { HomepageSection } from "@workspace/api-client-react";

export type HowItWorksStep = {
  heading: string;
  body: string;
};

export const DEFAULT_HOW_IT_WORKS_STEPS: HowItWorksStep[] = [
  {
    heading: "Straight from Pakistan",
    body: "Pieces from the labels you love, sourced for you.",
  },
  {
    heading: "Sizes you can trust",
    body: "We check availability when you open a piece.",
  },
  {
    heading: "Pay your way",
    body: "bKash, Nagad, Rocket or bank transfer.",
  },
  {
    heading: "Delivered to Dhaka",
    body: "About 14 to 20 days from your order date.",
  },
];

export function isHowItWorksSection(section: Pick<HomepageSection, "id">) {
  return section.id.startsWith("how-it-works-");
}

export function serializeHowItWorksSteps(steps: HowItWorksStep[]) {
  return JSON.stringify(steps.slice(0, 4));
}

export function parseHowItWorksSteps(value: string): HowItWorksStep[] {
  try {
    const parsed: unknown = JSON.parse(value);
    if (Array.isArray(parsed) && parsed.length === 4 && parsed.every(item =>
      typeof item === "object"
      && item !== null
      && typeof (item as Record<string, unknown>).heading === "string"
      && typeof (item as Record<string, unknown>).body === "string",
    )) {
      return parsed as HowItWorksStep[];
    }
  } catch {
    // Older or edited sections without the structured copy use the defaults.
  }
  return DEFAULT_HOW_IT_WORKS_STEPS.map(step => ({ ...step }));
}